import { getStatisticsRef } from 'db';
import { SHOW_ALERT } from "./ui";



export const FETCH_STATISTICS = "FETCH_STATISTICS";


export const watchingStatistics = (stat_id) => dispatch => {
  console.log("watching = ", stat_id);

  return getStatisticsRef(stat_id)
    .onSnapshot(docSnap => {
      console.log("docSnap = ", docSnap);
      if (docSnap.exists === false) {
        return dispatch({
          type: SHOW_ALERT,
          payload: {
            message: "통계 정보가 없습니다",
            color: 'danger',
          }
        });
      } else {
        dispatch({
          type: FETCH_STATISTICS,
          payload: docSnap
        });
      }
    }, e => {
      const message = e.code === 'permission-denied'
        ? '권한이 없습니다. 관리자에게 문의해주세요.'
        : `에러가 발생했습니다. ${e.message}`
      return dispatch({
        type: SHOW_ALERT,
        payload: {
          message,
          color: 'danger',
        }
      });
    });
}
